import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { cmsApi } from '../constants/constants'
@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) {
  }

  getDocumentList() {
    let URL = cmsApi + '/getDocList_web'
    let body = {}
    // console.log("getDocumentList");
    
    return this.http.post(URL, body)
  }
}
